module.exports = __webpack_public_path__ + "static/pyramids_alien_drawing3-d5002ec6331f10eef89e4f94b5e5ab48.png";